<section class="benefit-pillars-select">
    @if (block.data.description) {
        <div class="benefit-pillars-select__description" [innerHTML]="block.data.description"></div>
    }

    @if (block.content.length > 0) {
        <div class="benefit-pillars-select__cards">
            @for (card of block.content; track card.id) {
                @if (card.data.heading) {
                    <a
                        class="benefit-pillars-select-card"
                        routerLink="/benefits"
                        [queryParams]="
                            card.data.setFilteredBy
                                ? {
                                      filteredBy: card.data.filteredBy,
                                  }
                                : null
                        "
                        [attr.aria-labelledby]="'benefit-pillars-select-card-' + card.id">
                        @if (card.data.image) {
                            <img
                                class="benefit-pillars-select-card__image"
                                [src]="parseImageUrl(card.data.image_url)"
                                [alt]="card.data.heading" />
                        }

                        <div class="benefit-pillars-select-card__content">
                            <h2
                                [id]="'benefit-pillars-select-card-' + card.id"
                                class="benefit-pillars-select-card__heading">
                                {{ card.data.heading }}
                            </h2>

                            @if (card.data.description) {
                                <div
                                    class="benefit-pillars-select-card__description"
                                    [innerHTML]="card.data.description"></div>
                            }
                        </div>
                    </a>
                }
            }
        </div>
    }

    @if (block.data.includeCTA) {
        <a
            class="btn btn-primary benefit-pillars-select__cta"
            [href]="block.data.ctaLink"
            [target]="block.data.isExternalLink ? '_target' : '_self'"
            >{{ block.data.ctaLabel }}</a
        >
    }
</section>
